import api from './alerts.api'
import {
  GET_ALERTS_SUCCESS,
  GET_ALERTS_FAILURE,
  MARK_ALERT_READ_SUCCESS,
  MARK_ALERT_READ_FAILURE,
  CLEAR_ALERT_SUCCESS,
  CLEAR_ALERT_FAILURE,
  CLEAR_ALL_ALERTS_SUCCESS,
  CLEAR_ALL_ALERTS_FAILURE,
} from './alerts.constants'

export const getAlertsSuccess = alerts => ({
  type: GET_ALERTS_SUCCESS,
  alerts,
})

export const getAlertsFailure = error => ({
  type: GET_ALERTS_FAILURE,
  error,
})

export const markAlertReadSuccess = alerts => ({
  type: MARK_ALERT_READ_SUCCESS,
  alerts,
})

export const markAlertReadFailure = error => ({
  type: MARK_ALERT_READ_FAILURE,
  error,
})

export const clearAlertSuccess = alerts => ({
  type: CLEAR_ALERT_SUCCESS,
  alerts,
})

export const clearAlertFailure = error => ({
  type: CLEAR_ALERT_FAILURE,
  error,
})

export const clearAllAlertsSuccess = alerts => ({
  type: CLEAR_ALL_ALERTS_SUCCESS,
  alerts,
})

export const clearAllAlertsFailure = error => ({
  type: CLEAR_ALL_ALERTS_FAILURE,
  error,
})

export const getAlerts = (page, pageSize) => {
  return async dispatch => {
    try {
      const alerts = await api.getAlerts(page, pageSize)
      dispatch(getAlertsSuccess(alerts))
    } catch (e) {
      dispatch(getAlertsFailure(e))
    }
  }
}

export const markAlertRead = ({ id }) => {
  return async dispatch => {
    try {
      const alerts = await api.markAlertRead(id)
      dispatch(markAlertReadSuccess(alerts))
    } catch (e) {
      dispatch(markAlertReadFailure(e))
    }
  }
}

export const clearAlert = ({ id }) => {
  return async dispatch => {
    try {
      const alerts = await api.clearAlert(id)
      dispatch(clearAlertSuccess(alerts))
    } catch (e) {
      dispatch(clearAlertFailure(e))
    }
  }
}

export const clearAllAlerts = () => {
  return async dispatch => {
    try {
      const status = await api.clearAllAlerts()
      dispatch(clearAllAlertsSuccess(status))
    } catch (e) {
      dispatch(clearAllAlertsFailure(e))
    }
  }
}
